import { Avatar, Badge, Button, Dropdown, Menu, PageHeader, Row, Tag, Tooltip } from 'antd';
import React from 'react'
import history from '../../history';
import {FaBell, FaBoxes, FaUserAlt,} from 'react-icons/fa'
import { CodeSandboxOutlined, QrcodeOutlined ,UserOutlined,BellOutlined, SettingOutlined, LogoutOutlined} from '@ant-design/icons';
import '../../styles/style.css'
import './style.css'
import { connect } from 'react-redux';
import {logOut} from '../../actions/auth';
const menu  =  (api) => (
    <Menu style={{width: '200px', textAlign: 'center'}}>
      <Menu.Item onClick={() => history.push('/setting')}>
        <a rel="noopener noreferrer" href="#">
          <Avatar  shape="none" style={{margin: '0px', cursor: 'pointer', backgroundColor: '#fff', color: '#2C2E43'}} size={40} icon={<SettingOutlined />} /> Setting
        </a>
      </Menu.Item>
      <Menu.Item onClick={() => api() } >
        <a rel="noopener noreferrer" href="#" >
        <Avatar  shape="none" style={{margin: '0px', cursor: 'pointer', backgroundColor: '#fff', color: '#2C2E43'}} size={40} icon={<LogoutOutlined />} /> Logout </a>
      </Menu.Item>
      {/* <Menu.Item>
        <a rel="noopener noreferrer" href="http://www.tmall.com/">
          Logout
        </a>
      </Menu.Item> */}
    </Menu>
  );
const NotiDetails = (
    <Menu  style={{width: '200px', textAlign: 'center'}}>
      <Menu.Item>
        <a rel="noopener noreferrer" href="#">
          Notice 1
        </a>
      </Menu.Item>
      <Menu.Item>
        <a rel="noopener noreferrer" href="#">
          Notice 2
        </a>
      </Menu.Item>
      <Menu.Item>
        <a rel="noopener noreferrer" href="http://www.tmall.com/">
          Notice 3
        </a>
      </Menu.Item>
    </Menu>
  );

const DropdownMenu = ({api}) => (
  
    <Dropdown key="more" overlay={menu(api)} style={{}}>
     
        <Avatar className='setting' size={40} icon={<UserOutlined />} />
    </Dropdown>
  )

  const Notification = () => (
    <Dropdown key="more" overlay={NotiDetails}  >
      <Badge size='' count={5} className='notification-bell' style={{marginRight: '20px'}}>
        <Avatar  shape="none" className='notification'size={40} icon={<BellOutlined />} />
      </Badge>
    </Dropdown>
  )

  const Buttons = () => (
     <span>
     
     <Button size='large' onClick={() => history.push('/product-list') } className='ant-btn-primary' type="none" style={{border: 'none'}}  icon={<CodeSandboxOutlined />}>
        Products
      </Button>
      &nbsp;
     
      <Button size='large' onClick={() => history.push('/batch-list')}  className='ant-btn-primary'  style={{border: 'none'}} type="none" icon={<QrcodeOutlined />}>
        Batch Codes
      </Button>
      </span>
      
  )
const PTopbar = ({logOut}) => {
    return ( 
        <PageHeader
          style={{
            backgroundColor: "#FFF",
            boxShadow: '0px 2px 16px 1px rgba(0,0,0,0.47)',
            alignSelf: 'center',
            padding: '10px',
            
          }}
          tags={
            <div>
                <img onClick={() => history.push('/')} src='./logo.png' width='100px' style={{cursor: 'pointer', margin: '0px 20px'}} />
            </div>
          }
         
          
        >
        </PageHeader>
       
      
     );
}
 
export default connect(null,{logOut})(PTopbar);